import DIApi from './_diApi';

class BankInfoAPI extends DIApi {
  controllerName = 'BankInfos';
}

export default new BankInfoAPI();
